import { SpinnerLoader } from "@/components/spinner-loader";

export function FullScreenSpinnerLoader() {
  return (
    <div className="flex items-center justify-center h-screen">
      <SpinnerLoader />
    </div>
  );
}
